export default __webpack_public_path__ + "static/Blitz4 01F343DC-1560c213df5fafc951c1f359ae4a688c.jpg";